import React, { useState, Fragment } from 'react';
import { LegalModal } from './LegalModal';
import { TermsContent } from './legal/TermsContent';
import { PrivacyContent } from './legal/PrivacyContent';
import { CookiesContent } from './legal/CookiesContent';
import { RefundsContent } from './legal/RefundsContent';
export function Footer() {
  const [activeModal, setActiveModal] = useState<string | null>(null);
  const links = [{
    label: 'Términos y Condiciones',
    id: 'terms'
  }, {
    label: 'Privacidad',
    id: 'privacy'
  }, {
    label: 'Cookies',
    id: 'cookies'
  }, {
    label: 'Reembolsos y devoluciones',
    id: 'refunds'
  }, {
    label: 'Contacto',
    id: 'contact'
  }];
  const handleLinkClick = (id: string) => {
    setActiveModal(id);
  };
  const getModalContent = () => {
    switch (activeModal) {
      case 'terms':
        return {
          title: 'Términos y Condiciones',
          content: <TermsContent data-id="element-62" />
        };
      case 'privacy':
        return {
          title: 'Política de Privacidad',
          content: <PrivacyContent data-id="element-63" />
        };
      case 'cookies':
        return {
          title: 'Política de Cookies',
          content: <CookiesContent data-id="element-64" />
        };
      case 'refunds':
        return {
          title: 'Política de Reembolsos',
          content: <RefundsContent data-id="element-65" />
        };
      case 'contact':
        return {
          title: 'Contacto',
          content: <div className="prose prose-lg max-w-none" data-id="element-66">
              <p className="text-lg text-[#5a5a5a] mb-6" data-id="element-67">
                Para consultas, soporte o cualquier pregunta sobre nuestros
                productos, puedes contactarnos a través de:
              </p>
              <div className="bg-[#faf8f6] p-6 rounded-xl border-l-4 border-[#9d4b6b]" data-id="element-68">
                <p className="text-xl font-medium text-[#2d2d2d] mb-2" data-id="element-69">
                  Email de Soporte:
                </p>
                <a href="mailto:comarcar_sa@hotmail.com" className="text-2xl font-bold text-[#9d4b6b] hover:text-[#8b6f6f] transition-colors" data-id="element-70">
                  comarcar_sa@hotmail.com
                </a>
              </div>
              <p className="text-[#5a5a5a] mt-6" data-id="element-71">
                Nuestro equipo de soporte responderá a tu consulta lo antes
                posible, generalmente dentro de 24-48 horas hábiles.
              </p>
            </div>
        };
      default:
        return {
          title: '',
          content: null
        };
    }
  };
  const modalData = getModalContent();
  return <>
      <footer className="bg-[#1a1a1a] text-gray-400 py-12" data-id="element-72">
        <div className="max-w-7xl mx-auto px-6" data-id="element-73">
          {/* Copyright and Disclaimer Section */}
          <div className="mb-8 pb-8 border-b border-gray-800" data-id="element-74">
            <h3 className="text-xl font-serif font-bold text-white mb-4 text-center" data-id="element-75">
              Derechos de Autor y Descargo de Responsabilidad
            </h3>
            <div className="max-w-4xl mx-auto space-y-4 text-sm text-gray-400 leading-relaxed" data-id="element-76">
              <p className="text-center" data-id="element-77">
                © {new Date().getFullYear()}{' '}
                <span className="text-[#d4a5a5] font-medium" data-id="element-78">IdeoBooks</span> -
                Todos los derechos reservados.
              </p>
              <p data-id="element-79">
                Esta web no forma parte de Meta ni tampoco está recomendada por Meta Platforms, Inc. de ninguna forma.
Esta web no forma parte de Google ni de ninguna compañía vinculada a Google. 
Esta web tampoco está recomendada por Google de ninguna forma.
Esta web no forma parte de X ni tampoco está recomendada por X Corp. de ninguna forma.
No se permite reproducir, distribuir, transmitir, copiar, adaptar o almacenar este libro, total o parcialmente, por ningún medio, sin autorización previa y por escrito del autor, salvo citas breves con fines de reseña, artículo o uso académico. El contenido es una obra original y está protegido por las leyes de derechos de autor. El uso no autorizado puede dar lugar a acciones legales.
              </p>

              <p className="font-medium text-[#d4a5a5]" data-id="element-80">
                Este material es educativo y no sustituye terapia o
                acompañamiento profesional. Los resultados pueden variar según
                cada situación.
              </p>
            </div>
          </div>

          {/* Links */}
          <div className="flex flex-wrap justify-center items-center gap-4 md:gap-6 mb-6" data-id="element-81">
            {links.map((link, index) => <Fragment key={index} data-id="element-82">
                <button onClick={() => handleLinkClick(link.id)} className="text-sm hover:text-[#d4a5a5] transition-colors duration-200 cursor-pointer underline-offset-4 hover:underline" data-id="element-83">
                  {link.label}
                </button>
                {index < links.length - 1 && <span className="hidden md:inline text-gray-600" data-id="element-84">•</span>}
              </Fragment>)}
          </div>

          <p className="text-center text-sm text-gray-500" data-id="element-85">
            El Divorcio Emocional - Tu renacer amoroso comienza hoy
          </p>
        </div>
      </footer>

      {/* Legal Modal */}
      <LegalModal isOpen={activeModal !== null} onClose={() => setActiveModal(null)} title={modalData.title} data-id="element-86">
        {modalData.content}
      </LegalModal>
    </>;
}